import { useEffect } from 'react';
import { type RouterLocation, useLocationListener } from './location.hook';

/*
 ** Invokes the provided callback when the browser route changes
 */
export const useRouteChange = (onChange: (location: RouterLocation) => void) => {
	const listener = useLocationListener();

	useEffect(() => {
		return listener((location) => onChange(location));
	}, []);
};
